import { render, staticRenderFns } from "./ChatMessageImageDialog.vue?vue&type=template&id=5f6c9b82&scoped=true&"
import script from "./ChatMessageImageDialog.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageImageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageImageDialog.vue?vue&type=style&index=0&id=5f6c9b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c9b82",
  null
  
)

export default component.exports